<!--
 * @Author: Tina Huang
 * @Date: 2023-11-30 11:47:58
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2023-11-30 14:09:57
 * @Description: 
-->
<template>
  <div class="comments-box" v-if="isShow">
    <el-alert
      class="desc-alert"
      title="留言板"
      type="success"
      @close="handleClose"
      center
    ></el-alert>
    <div id="vcomments"></div>
    <router-link :to="{ name: 'comments' }" class="click"
      >- 查看所有留言 -</router-link
    >
  </div>
</template>
<script>
import Valine from "valine";
export default {
  data() {
    return {
      hideComments: false,
    };
  },
  computed: {
    pathname() {
      console.log("pathname: ", this.$route.name);
      return this.$route.name;
    },
    isShow() {
      if (this.hideComments) return false;
      const blackList = ["create", "mcreate", "paid", "comments"];
      if (blackList.includes(this.pathname)) return false;
      return true;
    },
  },
  mounted() {
    if (!this.isShow) return;
    new Valine({
      el: "#vcomments",
      // other config
      appId: "wgD3lhLSAPHdLGH0gPy9Ep5n-gzGzoHsz",
      appKey: "DX5XDbJapqKFh8XT5myBkrcc",
      avatar: "hide",
      path: "widvere-vcomments",
      visitor: true,
    });
  },
  methods: {
    handleClose() {
      this.hideComments = true;
    },
  },
};
</script>
<style lang="less" scoped>
.comments-box {
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 10%);
  border-radius: 5px;
  width: 200px;
  height: 360px;
  overflow: hidden;
  position: relative;
  .click {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    line-height: 2.5;
    background: rgba(132, 143, 224, 0.2);
    font-weight: bold;
  }
}
.el-alert__title {
  font-size: 14px !important;
}
</style>
